import React, { useEffect, useRef, useState } from 'react';
import {
  fromRole,
  isExpired,
  ProfileStatusMaster,
  ProjectModel,
  RecipientProfileStatusMaster,
  SbCurrentUser,
  SbRecipientModel,
  SbStatusMaster,
  SubmissionBoardModel,
  humanize,
  getProfileHeightString,
  getProfileWeightString,
  isUndefinedNullEmpty,
} from '../component/SbModel';
import { showToast } from '../../shared/Toast';
import { useMedia } from 'react-use';
import submissionBoardService from '../../services/SubmissionBoardService';
import SixDots from '../../../assets/images/6dotv.svg';
import sbProfilePlaceholder from '../../../../assets/images/sb_profile_placeholder.jpeg';
import whiteBgSbProfile from '../../../../assets/images/white_bg_sb_profile.jpeg';
import defaultUserAvatar from '../../../../assets/images/default_user_avatar.png';
// import {  Star as HeartOutlineIcon } from '@heroicons/react/24/outline';
// import { Star as HeartSolidIcon } from '@heroicons/react/24/solid';

import SbShowNotes from '../component/SbShowNotes';
import { Menu } from '@headlessui/react';
import ConfirmationDialog from '../../shared/ConfirmationDialog';
import SbMediaRequestNote from '../component/SbMediaRequestNote';
import InlineButton from '../component/InlineButton';
import {
  BookmarkIcon,
  CheckCircleIcon,
  CheckIcon,
  ChevronUpIcon,
  CircleMinusIcon,
  ClapperboardIcon,
  EllipsisVerticalIcon,
  EyeIcon,
  EyeOffIcon,
  FilmIcon,
  Star,
  MinusCircleIcon,
  NotepadTextIcon,
  PlusIcon,
  SquareUserIcon,
  StickyNoteIcon,
  UserIcon,
} from 'lucide-react';
import Button from '../component/Button';
import SbAddNote from '../component/SbAddNote';
import PreferredByRecipient from '../component/PreferredByRecipent';
import Image from '../../Image';
import { SUBMISSION_KIT_TAGS_HEADSHOT } from '../../../constants/SubmissionKit';
import { SubscriptionTier } from '../../user_plans/UserPlanModal';

interface SbProfileItemProps {
  currentUser: SbCurrentUser;
  submissionBoardModel: SubmissionBoardModel;
  project: ProjectModel;
  // key_token?: string;
  // otp_valid?: string;

  profileUser: any;
  fromScreen: string;
  viewMode?: 'grid' | 'list';
  refreshSubmissionBoard?: () => void;
  updateSubmissionBoardCounts?: (
    sbId: number,
    profileStatusChange: {
      type: 'add' | 'remove' | 'status_change';
      oldStatus?: number;
      newStatus?: number;
    }
  ) => void;
  profileIndex: number;
  prevNextProfile?: (value: number, profileIndex: number) => void;
  // showProfileDetailInModal?: any;
  sb_recipient?: SbRecipientModel;
}

export const SbProfileListItem: React.FC<SbProfileItemProps> = ({
  currentUser,
  submissionBoardModel,
  // key_token,
  // otp_valid,
  project,
  profileUser,
  fromScreen,
  viewMode = 'list',
  refreshSubmissionBoard,
  updateSubmissionBoardCounts,
  profileIndex,
  prevNextProfile,
  sb_recipient,
}) => {
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);
  const [isSbLocked, setIsSbLocked] = useState(false);
  const [isSelectionDone, setIsSelectionDone] = useState(false);
  const [showModalNotes, setShowModalNotes] = useState(false);
  const [showAddNoteModal, setShowAddNoteModal] = useState(false);
  const [profileUserInfo, setProfileUserInfo] = useState(profileUser);
  const [sbProfileStatus, setSbProfileStatus] = useState(null);
  // const [sbProfileStatus, setSbProfileStatus] = useState(null);
  const [showCoordinatorNote, setShowCoordinatorNote] = useState(false);

  const [notes, setNotes] = useState(
    profileUser?.sb_profiles &&
      profileUser?.sb_profiles.length > 0 &&
      profileUser?.sb_profiles[0]?.notes
  );

  const [showMediaRequestModal, setShowMediaRequestModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationDialog] = useState(false);
  const [confirmDialogActions, setConfirmDialogActions] = useState(null);
  const [documentCount, setDocumentCount] = useState(0);

  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);

  // request notes

  const [isServerOperation, setIsServerOperation] = useState(false);
  const [showRequestMediaNote, setShowRequestMediaNote] = useState(false);
  const [requestMediaNote, setRequestMediaNote] = useState('');
  const [noteCount, setNoteCount] = useState(0);

  const divRef = useRef(null);
  const [heightImage, setHeightImage] = useState('0px');

  // Check if any profile is already backed up
  const isAnyProfileBackedUp = () => {
    if (!selectedSubmissionBoard || !selectedSubmissionBoard.profiles) return false;

    // Check if any profile (including current) is backed up
    return selectedSubmissionBoard.profiles.some(
      (item) => item?.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.BackupSelected
    );
  };
  // Function to calculate and set the height
  const calculateHeight = () => {
    if (divRef.current) {
      // Get the current width of the div
      const width = divRef.current.offsetWidth;
      if (width > 0) {
        // Set the height based on a 4:5 ratio (height = width * 5/4)
        const calculatedHeight = width * (5 / 4);
        setHeightImage(calculatedHeight + 'px');
      }
    }
  };

  // Effect to run on initial render and when the window resizes
  useEffect(() => {
    // Use requestAnimationFrame to ensure DOM is ready
    const timeoutId = setTimeout(() => {
      calculateHeight();
    }, 0);

    // Add a resize listener
    window.addEventListener('resize', calculateHeight);

    // Clean up the event listener when the component unmounts
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', calculateHeight);
    };
  }, []);

  // Recalculate height when profileUserInfo changes (new image)
  useEffect(() => {
    // Small delay to ensure DOM is updated
    const timeoutId = setTimeout(() => {
      calculateHeight();
    }, 100);
    return () => clearTimeout(timeoutId);
  }, [profileUserInfo?.croppedAvatarUrl, profileUserInfo?.imageUrl]);

  useEffect(() => {
    let initialCount = 0;
    if (profileUser?.sb_profiles && profileUser?.sb_profiles.length > 0) {
      profileUser?.sb_profiles.forEach((item1) => {
        // Count note_texts from sb_profile_notes if available
        if (item1.note_texts && Array.isArray(item1.note_texts)) {
          initialCount += item1.note_texts.length;
        }
        // Count existing notes as fallback
        // if (item1.notes) {
        //   initialCount += 1;
        // }
        // if (item1?.sb_profiles_statuses && item1?.sb_profiles_statuses.length > 0) {
        //   item1?.sb_profiles_statuses.forEach((item2) => {
        //     if (item2.notes) {
        //       initialCount += 1;
        //     }
        //   });
        // }
      });
    }
    setNoteCount(initialCount);
  }, [profileUser]);

  useEffect(() => {
    if (
      submissionBoardModel.sb_status == SbStatusMaster.expired ||
      submissionBoardModel.sb_status == SbStatusMaster.locked ||
      isExpired(submissionBoardModel?.expire_at)
    ) {
      setIsSbLocked(true);
    } else {
      setIsSbLocked(false);
    }
    setSelectedSubmissionBoard(submissionBoardModel);
  }, [submissionBoardModel]);

  // Check if profile should be shown when submission board is locked
  const shouldShowProfile = () => {
    // Always show all profiles regardless of submission board lock status
    return true;
  };

  // Helper function to check if profile has a valid image
  const hasValidProfileImage = () => {
    const croppedAvatar = profileUserInfo?.croppedAvatarUrl;
    const imageUrl = profileUserInfo?.imageUrl;
    
    const isValidCroppedAvatar = croppedAvatar && 
      croppedAvatar !== 'icons/default_avatar.svg' && 
      !croppedAvatar.includes('default_avatar');
    
    const isValidImageUrl = imageUrl && 
      imageUrl !== 'icons/default_avatar.svg' && 
      !imageUrl.includes('default_avatar');
    
    return isValidCroppedAvatar || isValidImageUrl;
  };

  // Helper function to get the profile image URL
  const getProfileImageUrl = () => {
    const croppedAvatar = profileUserInfo?.croppedAvatarUrl;
    const imageUrl = profileUserInfo?.imageUrl;
    
    const isValidCroppedAvatar = croppedAvatar && 
      croppedAvatar !== 'icons/default_avatar.svg' && 
      !croppedAvatar.includes('default_avatar');
    
    if (isValidCroppedAvatar) {
      return croppedAvatar;
    }
    
    const isValidImageUrl = imageUrl && 
      imageUrl !== 'icons/default_avatar.svg' && 
      !imageUrl.includes('default_avatar');
    
    if (isValidImageUrl) {
      return imageUrl;
    }
    
    return sbProfilePlaceholder;
  };
  useEffect(() => {
    console.log('profileUser', profileUser);
    if (
      profileUser?.sb_profiles &&
      profileUser.sb_profiles?.length > 0 &&
      profileUser.sb_profiles[0]?.sb_profiles_statuses &&
      profileUser.sb_profiles[0]?.sb_profiles_statuses?.length > 0
    ) {
      let resp = null;
      if (sb_recipient != undefined) {
        resp = profileUser.sb_profiles[0]?.sb_profiles_statuses.find(
          (item) => item.sb_recipient_id == sb_recipient.id
        );
      } else {
        resp = profileUser.sb_profiles[0]?.sb_profiles_statuses.find(
          (item) => item.user_id == currentUser.id
        );
        if (resp) {
        } else {
          // for a given recipient, match with recipient current user id
          for (
            let indexStatus = 0;
            indexStatus < profileUser.sb_profiles[0]?.sb_profiles_statuses.length;
            indexStatus++
          ) {
            const item = profileUser.sb_profiles[0]?.sb_profiles_statuses[indexStatus];
            if (
              item.sb_recipient_id != null &&
              selectedSubmissionBoard?.recipients &&
              selectedSubmissionBoard?.recipients.length > 0
            ) {
              const resp1 = selectedSubmissionBoard?.recipients.find(
                (item2) =>
                  item2.sb_recipient_id == item.sb_recipient_id && item2.id == currentUser.id
              );
              if (resp1) {
                resp = item;
                break;
              }
            }
          }
        }
      }
      if (resp) {
        setSbProfileStatus(resp);
      } else {
        setSbProfileStatus(null);
      }
    }
    setProfileUserInfo(profileUser);
  }, [profileUser]);

  useEffect(() => {
    if (!selectedSubmissionBoard || !selectedSubmissionBoard.profiles){
      return ;
    }
    const maxHire = selectedSubmissionBoard.multiple_hire ?? 1;
    const effectiveMaxHire = maxHire === 0 ? 1 : maxHire;
    const selectedCount = selectedSubmissionBoard.profiles.filter(
      (item) =>
        item?.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Selected ||
        item?.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Onboard
    ).length;
    console.log('selectedCount', selectedCount, 'effectiveMaxHire', effectiveMaxHire);
    setIsSelectionDone( selectedCount >= effectiveMaxHire);
  }, [selectedSubmissionBoard]);

  const removePerformerFromSbClickHandler = async () => {
    try {
      await submissionBoardService.removePerformerFromSubmissionBoard(
        project.uuid,
        selectedSubmissionBoard.id,
        profileUserInfo.id
      );
      if (refreshSubmissionBoard) {
        refreshSubmissionBoard();
      }
      showToast(
        'Shortlisted ' +
          profileUserInfo.firstName +
          ' ' +
          profileUserInfo.lastName +
          ' performer removed',
        'success'
      );
    } catch (error) {
      console.error('Error shortlisting profile:', error);
      var errorMsg = error.response?.data?.error;
      showToast(errorMsg ?? 'Failed to remove performer, please try again', 'danger');
    }
  };

  const pendingClickHandler = async () => {
    const resp = await profileStatusSave(ProfileStatusMaster.Pending); // approved
    if (resp) {
      showToast(
        'Removed status of  ' + profileUserInfo.firstName + ' ' + profileUserInfo.lastName,
        'success'
      );
    }
  };
  const finalSelectionClickHandler = async () => {
    setConfirmDialogActions({
      onConfirm: async () => {
        const resp = await profileStatusSave(ProfileStatusMaster.Selected); // approved
        if (resp) {
          showToast(
            'Accepted ' + profileUserInfo.firstName + ' ' + profileUserInfo.lastName,
            'success'
          );
        }
        setShowConfirmationDialog(false);
      },
      onCancel: () => {
        setShowConfirmationDialog(false);
      },
    });
    setShowConfirmationDialog(true);
  };

  const backupAcceptClickHandler = async () => {
    const resp = await profileStatusSave(ProfileStatusMaster.BackupSelected); // approved
    if (resp) {
      showToast(
        'Accepted ' + profileUserInfo.firstName + ' ' + profileUserInfo.lastName,
        'success'
      );
    }
  };

  const rejectClickHandler = async () => {
    // Check if profile is currently rejected (hidden)
    const isCurrentlyHidden =
      profileUserInfo?.sb_profiles[0]?.profile_status === ProfileStatusMaster.Rejected;
    if (isCurrentlyHidden) {
      // Unhide: set to pending
      const resp = await profileStatusSave(ProfileStatusMaster.Pending);
      if (resp) {
        showToast(
          'Unhidden ' + profileUserInfo.firstName + ' ' + profileUserInfo.lastName,
          'success'
        );
      }
    } else {
      // Hide: set to rejected
      const resp = await profileStatusSave(ProfileStatusMaster.Rejected);
      if (resp) {
        showToast(
          'Hidden ' + profileUserInfo.firstName + ' ' + profileUserInfo.lastName,
          'success'
        );
      }
    }
  };
  //  check if current user can hide profiles
  const isSelectionDoneHideAll = () => {
    if (selectedSubmissionBoard.multiple_hire <= 1) {
      // if any profile is sehidelected or added then hide all button
      const resp = selectedSubmissionBoard.profiles.filter((item) => {
        return (
          item?.sb_profiles[0]?.profile_status === ProfileStatusMaster.Selected ||
          item?.sb_profiles[0]?.profile_status === ProfileStatusMaster.Onboard
        );
      });
      // When multiple_hire is 0, allow 1 final selection before hiding
      const maxAllowed = selectedSubmissionBoard.multiple_hire === 0 ? 1 : 1;
      if (resp.length >= maxAllowed) {
        return true;
      }
    }
    return false;
  };
  // is Max FinalSelected Reached
  // const isMaxFinalSelectedReached = () => {
  //   if (!selectedSubmissionBoard || !selectedSubmissionBoard.profiles) return false;
  //   const maxHire = selectedSubmissionBoard.multiple_hire ?? 1;
  //   const effectiveMaxHire = maxHire === 0 ? 1 : maxHire;
  //   const selectedCount = selectedSubmissionBoard.profiles.filter(
  //     (item) =>
  //       item?.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Selected ||
  //       item?.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Onboard
  //   ).length;
  //   console.log('selectedCount', selectedCount, 'effectiveMaxHire', effectiveMaxHire);
  //   return selectedCount >= effectiveMaxHire;
  // };
  //  check if current user can hide profiles
  const canHideProfiles = () => {
    const allowedRoles = ['super_coordinator', 'coordinator_admin', 'stunt_office_coordinator'];
    return currentUser.role && allowedRoles.includes(currentUser.role);
  };
  //  check if profile is currently hidden (rejected)
  const isProfileHidden = () => {
    return profileUserInfo?.sb_profiles[0]?.profile_status === ProfileStatusMaster.Rejected;
  };

  const profileStatusSave = async (profile_status: number) => {
    try {
      setIsServerOperation(true);
      if (
        project == undefined ||
        project == null ||
        selectedSubmissionBoard == undefined ||
        selectedSubmissionBoard == null
      ) {
        throw new Error('Error: Invalid data selection.');
      }
      // Get the old status before updating
      const oldStatus = profileUserInfo?.sb_profiles?.[0]?.profile_status;
      const response = await submissionBoardService.updatePerformerStatusSb(
        project.uuid,
        selectedSubmissionBoard.id,
        profileUserInfo.id,
        profile_status,
        sb_recipient && sb_recipient.key_token ? sb_recipient.key_token : '',
        sb_recipient && sb_recipient.otp_valid ? sb_recipient.otp_valid : ''
      );

      // Update counts directly without API call
      if (updateSubmissionBoardCounts && oldStatus !== undefined) {
        updateSubmissionBoardCounts(selectedSubmissionBoard.id, {
          type: 'status_change',
          oldStatus: oldStatus,
          newStatus: profile_status,
        });
      }

      // Update local state
      setProfileUserInfo((prev) => ({
        ...prev,
        sb_profiles: [
          {
            ...prev.sb_profiles[0],
            profile_status: profile_status,
          },
        ],
      }));

      setSelectedSubmissionBoard((prev) => {
        if (!prev || !prev.profiles) return prev;
        return {
          ...prev,
          profiles: prev.profiles.map((profile) =>
            profile.id === profileUserInfo.id
              ? {
                  ...profile,
                  sb_profiles: [
                    {
                      ...profile.sb_profiles[0],
                      profile_status: profile_status,
                    },
                  ],
                }
              : profile
          ),
        };
      });

      if (refreshSubmissionBoard) {
        refreshSubmissionBoard();
      }

      return true;
    } catch (error) {
      console.error('Error shortlisting profile:', error);
      var errorMsg = error.response?.data?.error;
      showToast(errorMsg ?? 'Failed to shortlist, please try again', 'danger');
    } finally {
      setIsServerOperation(false);
    }
    return false;
  };

  // const saveNoteClickHandler = async () => {
  //   try {
  //     if (
  //       project == undefined ||
  //       project == null ||
  //       selectedSubmissionBoard == undefined ||
  //       selectedSubmissionBoard == null
  //     ) {
  //       throw new Error('Error: Invalid data selection.');
  //     }
  //     const response = await submissionBoardService.updatePerformerNoteSb(
  //       project.uuid,
  //       selectedSubmissionBoard.id,
  //       profileUserInfo.id,
  //       notes
  //     );

  //     let _profileUserInfo = { ...profileUserInfo };
  //     if (_profileUserInfo?.sb_profiles && _profileUserInfo?.sb_profiles.length > 0) {
  //       _profileUserInfo.sb_profiles[0].notes = notes;
  //       setProfileUserInfo(_profileUserInfo);
  //       setShowCoordinatorNote(false);
  //       showToast(
  //         'Added notes for  ' + profileUserInfo.firstName + ' ' + profileUserInfo.lastName,
  //         'success'
  //       );
  //     }
  //     return true;
  //   } catch (error) {
  //     console.error('Error shortlisting profile:', error);
  //     var errorMsg = error.response?.data?.error;
  //     showToast(errorMsg ?? 'Failed to shortlist, please try again', 'danger');
  //   }
  //   return false;
  // };
  const requestMediaClickHandler = async () => {
    setShowMediaRequestModal(true);
  };
  const likeClickHandler = async () => {
    const resp = await profileActionSave(RecipientProfileStatusMaster.Liked); // liked
    if (resp) {
      showToast('Liked ' + profileUser.firstName + ' ' + profileUser.lastName, 'success');
    }
  };
  const unlikeClickHandler = async () => {
    const resp = await profileActionSave(RecipientProfileStatusMaster.Unliked); // unliked
    if (resp) {
      showToast('Profile preference updated for ' + profileUser.firstName + ' ' + profileUser.lastName, 'success');
    }
  };
  const profileActionSave = async (profile_status: number) => {
    try {
      setIsServerOperation(true);
      if (
        project == undefined ||
        project == null ||
        selectedSubmissionBoard == undefined ||
        selectedSubmissionBoard == null
      ) {
        throw new Error('Error: Invalid data selection.');
      }
      const resp = await submissionBoardService.addRecipientFeedback(
        project.uuid,
        selectedSubmissionBoard.id,
        profileUser.id,
        sb_recipient && sb_recipient.key_token ? sb_recipient.key_token : '',
        sb_recipient ? sb_recipient.id : 0,
        profile_status,
        notes
      );
      if (resp) {
        console.log('resp', resp);
        if (refreshSubmissionBoard) {
          refreshSubmissionBoard();
        }
      }
      return true;
    } catch (error) {
      console.error('Error shortlisting profile:', error);
      var errorMsg = error.response?.data?.error;
      showToast(errorMsg ?? 'Failed to shortlist, please try again', 'danger');
    } finally {
      setIsServerOperation(false);
    }
    return false;
  };
  // If profile media
  useEffect(() => {
    const imageUrl = profileUserInfo?.croppedAvatarUrl || profileUserInfo?.imageUrl;
    
        let kitDocuments = [];
          if (
          profileUserInfo?.sb_profiles_media &&
          profileUserInfo.sb_profiles_media != null &&
          profileUserInfo.sb_profiles_media.sb_profiles_medias &&
          profileUserInfo.sb_profiles_media.sb_profiles_medias.length > 0
        ) {
          const tagVideos = profileUserInfo.sb_profiles_media.sb_profiles_medias;
          kitDocuments = [...kitDocuments, ...tagVideos];
        }
    
        if (
          profileUserInfo?.submission_kit &&
          profileUserInfo.submission_kit != null &&
          profileUserInfo.submission_kit.submission_kit_documents &&
          profileUserInfo.submission_kit.submission_kit_documents.length > 0
        ) {
          let _submissionkitDocuments = profileUserInfo.submission_kit.submission_kit_documents.filter((itemSkd) => {
                    if(kitDocuments.findIndex((itemKd) => itemKd.tag == itemSkd.tag && itemKd.media_status == 'Add') >= 0)
                    {
                      return false;
                    }
                    if(kitDocuments.findIndex((itemKd) => itemKd.tag == itemSkd.tag && itemKd.media_status == 'Remove') >= 0)
                    {
                      return false;
                    }
                    return true;
                  })
          kitDocuments = [...kitDocuments, ..._submissionkitDocuments];
        }
        
        kitDocuments = kitDocuments.filter((item) => item.media_status == undefined || item.media_status !== 'Remove');
        // For free/archive users defult headshot 
        let isAddHeadShot = false;
          // Recipient viewing performer's submission
        isAddHeadShot = profileUserInfo && 
          (profileUserInfo.subscription_tier === SubscriptionTier.free || profileUserInfo.subscription_tier === SubscriptionTier.archive);
      
    
        if(!isAddHeadShot && kitDocuments.filter((item) => item.tag.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase()).length <=0 )
        { // if headshot is removed from kit
          if((profileUserInfo?.croppedAvatarUrl || profileUserInfo?.imageUrl) && 
            (profileUserInfo?.croppedAvatarUrl || profileUserInfo.imageUrl) !== 'icons/default_avatar.svg' &&
            (profileUserInfo?.croppedAvatarUrl || profileUserInfo.imageUrl) !== '')
          {
          isAddHeadShot = true;
          }
        }
        if (isAddHeadShot) {
          
          const hasProfileImage = (profileUserInfo?.croppedAvatarUrl || profileUserInfo?.imageUrl) && 
                                 (profileUserInfo?.croppedAvatarUrl || profileUserInfo.imageUrl) !== 'icons/default_avatar.svg' &&
                                 (profileUserInfo?.croppedAvatarUrl || profileUserInfo.imageUrl) !== '';
          
          if (hasProfileImage) {
            const defaultHeadshot = {
              id: -1,
              submission_kit_id: -1,
              kit_document_id: -1,
              tag: SUBMISSION_KIT_TAGS_HEADSHOT,
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
              kit_document: {
                id: -1,
                featured: 0,
                created_at: new Date().toISOString(),
                uuid: '',
                record_id: -1,
                file_url: profileUserInfo?.croppedAvatarUrl || profileUserInfo.imageUrl,
                file_name: 'headshot',
                file_content_type: 'image/jpeg',
                cropped_file_url: null,
                cropped_file_name: null,
                cropped_file_content_type: null,
                work_kit_id: null,
                wardrobe_kit_id: null,
                hair_make_up_kit_id: null,
              },
            };
            
            // Remove any existing headshot documents and add the default one
            kitDocuments = kitDocuments.filter(
              (item) => item.tag.toLowerCase() !== SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase()
            );
            kitDocuments.push(defaultHeadshot);
          }
        }
    // let documentsLength = 0;

    // const documents = profileUserInfo?.submission_kit?.submission_kit_documents;
    // if(documents && documents.length > 0) {
    //   documentsLength = documentsLength + documents.length;
    //   if(documents.filter((item) => item.tag.toLowerCase() == SUBMISSION_KIT_TAGS_HEADSHOT).length <= 0
    //   && imageUrl && imageUrl !== 'icons/default_avatar.svg') {
    //     documentsLength += 1;
    //   }
    // }

    // const sb_documents = profileUserInfo?.sb_profiles_media?.sb_profiles_medias;
    // if(sb_documents && sb_documents.length > 0) {
    //   documentsLength = documentsLength + sb_documents.filter((item) => item.media_status == 'Add').length;
    // }

    if (kitDocuments.length > 0) {
      console.log('Documents found:', kitDocuments.length);
      setDocumentCount(kitDocuments.length);
    } else if (imageUrl && imageUrl !== 'icons/default_avatar.svg') {
      setDocumentCount(1);
    } else {
      console.log('No documents or valid image URL found');
      setDocumentCount(0);
    }
  }, [profileUserInfo]);

  const getSelectedUser = (updated_by_user_id, profile_status, sb_recipient_id) => {
    // If profile is onboarded (status 4), show "Added to Team"
    if (profile_status === ProfileStatusMaster.Onboard) {
      return 'Added to Team';
    }
    // If profile is backup approved (status 3), show "Backup By [Name]"
    if (profile_status === ProfileStatusMaster.BackupSelected) {
      const text = 'Backed By ';
      
      // First check if it's a recipient by sb_recipient_id
      const recipient = selectedSubmissionBoard.recipients?.find((item) => {
        return item.sb_recipient_id === sb_recipient_id;
      });
      if (recipient) {
        return text + recipient.email;
      }
      
      // Check coordinators with different possible field names
      let resp = selectedSubmissionBoard.coordinators?.find((item) => {
        return item.user_id == updated_by_user_id;
      });
      if (resp) {
        const name =
          resp.name ||
          // (resp.first_name && resp.last_name ? resp.first_name + ' ' + resp.last_name : '') ||
          resp.email;
        return text + name;
      }
      
      const recipientByUserId = selectedSubmissionBoard.recipients?.find((item) => {
        return // item.user_id == updated_by_user_id || 
        item.id == updated_by_user_id;
      });
      if (recipientByUserId) {
        return text + recipientByUserId.email;
      }
      // If not found, try to get current user info
      if (currentUser && updated_by_user_id == currentUser.id) {
        const name =
          (currentUser.first_name && currentUser.last_name
            ? currentUser.first_name + ' ' + currentUser.last_name
            : '') || currentUser.email;
        return text + name;
      }
      return 'Backup';
    }
    const text = 'Selected By ';
    
    if(!isUndefinedNullEmpty(sb_recipient_id)) {
        let respRec = selectedSubmissionBoard.recipients?.find((item) => {
          return item.sb_recipient_id == sb_recipient_id;
        });
        if (respRec) {
          return text + (respRec.name && respRec.name != '' ? respRec.name : respRec.email);
        }
      }
    const recipientByUserId = selectedSubmissionBoard.recipients?.find((item) => {
      return item.id == updated_by_user_id;
    });
    if (recipientByUserId) {
      return text + (recipientByUserId.name && recipientByUserId.name != '' ?recipientByUserId.name : recipientByUserId.email);
    }
    // Check coordinators with different possible field names
    let resp = selectedSubmissionBoard.coordinators?.find((item) => {
      return item.user_id == updated_by_user_id
    });
    if (resp) {
      const name = resp.name || resp.email;
      return text + name;
    }

    // If not found, try to get current user info
    if (currentUser && updated_by_user_id == currentUser.id) {
      const name =
        (currentUser.first_name && currentUser.last_name
          ? currentUser.first_name + ' ' + currentUser.last_name
          : '') || currentUser.email;
      return <span className="text-blue-500">{text + name}</span>;
    }
    return 'Selected';
  };
  const addToTeamClickHandler = async () => {
    try {
      setIsServerOperation(true);
      // Prepare user data for the create API
      //  sends notify_added_to_project email
      let userData = {
        user_id: profileUserInfo.id,
        user: {
          email: profileUserInfo.email,
          first_name: profileUserInfo.firstName,
          last_name: profileUserInfo.lastName,
        },
        project_id: project.uuid,
        role: 'performer',
        role_name: 'Performer',
      };
      if(selectedSubmissionBoard.project_folder_uuid && selectedSubmissionBoard.project_folder_uuid != undefined)
      {
        userData.project_folder_id = selectedSubmissionBoard.project_folder_uuid;
      }
      // project_folder_id
      // Call the service method to add user to project with performer role
      const response = await submissionBoardService.addUserToProject(
        project.uuid,
        userData,
        sb_recipient && sb_recipient.key_token ? sb_recipient.key_token : '',
        sb_recipient && sb_recipient.otp_valid ? sb_recipient.otp_valid : ''
      );
      // Update profile status to onboard (4) after successful API call
      await profileStatusSave(ProfileStatusMaster.Onboard); // onboard status
      showToast(
        'Successfully added ' +
          profileUserInfo.firstName +
          ' ' +
          profileUserInfo.lastName +
          ' to the team',
        'success'
      );
      // Note: profileStatusSave already handles count updates via callback
    } catch (error) {
      console.error('Error adding to team:', error);
      showToast(error.message || 'Failed to add to team, please try again', 'danger');
    } finally {
      setIsServerOperation(false);
    }
  };
  // Don't render the component if profile shouldn't be shown
  if (!shouldShowProfile()) {
    return null;
  }
  const FinalButton = () => {
    return (
      <>
        {!isSbLocked &&
          profileUserInfo &&
          !isSelectionDoneHideAll() &&
          profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Selected &&
          profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard &&
          !isSelectionDone && (
            <Button
              id={'sb_final_accept_profile_btn_id_' + profileIndex}
              variant="primary"
              btn_size="small"
              icon_position="hor"
              className={` 
        ${isProfileHidden() ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : ''}`}
              disabled={isProfileHidden() || isServerOperation}
              onClick={() => {
                finalSelectionClickHandler();
              }}
            >
              <div className="w-6 h-6 p-3px flex items-center justify-center">
                <CheckIcon className="w-4-2 h-4-2" aria-hidden="true" />
              </div>
              Final Selection
            </Button>
          )}
      </>
    );
  };
  const ShowSelectedOnboardedInfo = () => {
    return (
      <>
        {(profileUserInfo.sb_profiles[0].profile_status === ProfileStatusMaster.Selected ||
          profileUserInfo.sb_profiles[0].profile_status === ProfileStatusMaster.Onboard) && (
          <Button
            id={'sb_accepted_profile_btn_id_' + profileIndex}
            variant="primary"
            btn_size="small"
            icon_position="hor"
            className={`cursor-default break-all w-full flex items-center justify-center gap-2 px-4 py-3 font-medium rounded-md
                              ${
                                profileUserInfo.sb_profiles[0].profile_status ===
                                ProfileStatusMaster.Onboard
                                  ? 'border-2 border-green-500 bg-mint-cream text-black'
                                  : 'border-2 border-blue-100 bg-heart-of-ice text-black'
                              }`}
            onClick={() => {}}
          >
            <div
              className={`w-6 h-6 p-3px flex items-center justify-center"
                            ${
                              profileUserInfo.sb_profiles[0].profile_status ===
                              ProfileStatusMaster.Onboard
                                ? ' text-green-500 '
                                : ' text-blue-500 '
                            }`}
            >
              <CheckCircleIcon className="w-4-2 h-4-2" aria-hidden="true" />
            </div>
            <span className="truncate flex-1" style={{}}>
              {getSelectedUser(
                profileUserInfo.sb_profiles[0].updated_by,
                profileUserInfo.sb_profiles[0].profile_status,
                profileUserInfo.sb_profiles[0].sb_recipient_id
              )}
            </span>
          </Button>
        )}
      </>
    );
  };
  const ShowBackSelectedInfo = () => {
    return (
      <>
        {profileUserInfo.sb_profiles[0].profile_status === ProfileStatusMaster.BackupSelected && (
          <Button
            id={'sb_backed_profile_btn_id_' + profileIndex}
            variant="secondary"
            btn_size="small"
            icon_position="hor"
            className={`cursor-default text-gray-500 bg-gray-100 break-all w-full flex items-center justify-center gap-2 px-4 py-3 font-medium rounded-md`}
          >
            <div className={`w-6 h-6 p-3px flex items-center justify-center"`}>
              <BookmarkIcon className="w-4-2 h-4-2" aria-hidden="true" />
            </div>
            <span className="truncate" style={{}}>
              {getSelectedUser(
                profileUserInfo.sb_profiles[0].updated_by,
                profileUserInfo.sb_profiles[0].profile_status,
                profileUserInfo.sb_profiles[0].sb_recipient_id
              )}
            </span>
          </Button>
        )}
      </>
    );
  };
  const AddToTeamButton = () => {
    return (
      <>
        {!isSbLocked &&
          fromScreen == fromRole.SB_CREATOR &&
          profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard &&
          profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.BackupSelected && (
            <Button
              id={'sb_addteam_profile_btn_id_' + profileIndex}
              variant="primary"
              btn_size="small"
              icon_position="hor"
              className={`
                             ${
                               isProfileHidden()
                                 ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                 : ''
                             }`}
              disabled={isProfileHidden() || isServerOperation}
              onClick={() => {
                addToTeamClickHandler();
              }}
            >
              <div className="w-6 h-6 p-3px flex items-center justify-center">
                <PlusIcon className="w-4-2 h-4-2" aria-hidden="true" />
              </div>
              <span className="truncate">Add to Team</span>
            </Button>
          )}{' '}
      </>
    );
  };
  const RemoveSelectionButton = () => {
    return (
      <>
        {!isSbLocked &&
          profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard && (
            <Button
              id={'sb_remove_select_profile_btn_id_' + profileIndex}
              variant="secondary"
              btn_size="small"
              icon_position="hor"
              className={`
           ${isProfileHidden() ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : ''}`}
              disabled={isProfileHidden() || isServerOperation}
              onClick={() => {
                pendingClickHandler();
              }}
            >
              <div className="w-6 h-6 p-3px flex items-center justify-center">
                <MinusCircleIcon className="w-4-2 h-4-2" aria-hidden="true" />
              </div>
               <span className="truncate">
                {profileUserInfo.sb_profiles[0].profile_status === ProfileStatusMaster.Selected
                  ? 'Remove as Final'
                  : profileUserInfo.sb_profiles[0].profile_status ===
                    ProfileStatusMaster.BackupSelected
                    ? 'Remove as Backup'
                    : 'Remove Selection'}
              </span>
            </Button>
          )}
      </>
    );
  };
  // Helper function to check if BackupButton should be visible
  const isBackupButtonVisible = () => {
    return (
      (selectedSubmissionBoard?.multiple_hire ?? 1) <= 1 &&
      !isAnyProfileBackedUp() &&
      profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.BackupSelected &&
      profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Selected &&
      profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard
    );
  };

  const BackupButton = (props: { icon_position: 'hor' | 'ver' }) => {
    return (
      <>
        {
          //profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard &&
          //profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.BackupSelected &&
          (selectedSubmissionBoard?.multiple_hire ?? 1) <= 1 && !isAnyProfileBackedUp() && (
            <>
              {profileUserInfo.sb_profiles[0].profile_status !==
                ProfileStatusMaster.BackupSelected &&
                profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Selected &&
                profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard && (
                  <Button
                    id={'sb_bkp_accept_profile_btn_id_' + profileIndex}
                    variant="secondary"
                    btn_size="small"
                    icon_position={props.icon_position}
                    className={`w-full ${
                      isProfileHidden() ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : ''
                    }`}
                    disabled={isProfileHidden()}
                    onClick={() => {
                      backupAcceptClickHandler();
                    }}
                  >
                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                      <BookmarkIcon className="w-4-2 h-4-2" aria-hidden="true" />
                    </div>
                    Backup
                    {/* {profileUserInfo.sb_profiles[0].profile_status ===
                            ProfileStatusMaster.BackupSelected
                              ? getSelectedUser(
                                  profileUserInfo.sb_profiles[0].updated_by,
                                  ProfileStatusMaster.BackupSelected
                                )
                              : 'Backup'} */}
                  </Button>
                )}
              {/* {profileUserInfo.sb_profiles[0].profile_status ===
                      ProfileStatusMaster.BackupSelected && (
                      <Button
                        id={'sb_selected_profile_btn_id_' + profileIndex}
                        variant="primary"
                        btn_size="small"
                        icon_position="hor"
                        className={`break-all w-full flex items-center justify-center gap-2 px-4 py-3 font-medium rounded-md
                        ${
                          profileUserInfo.sb_profiles[0].profile_status === ProfileStatusMaster.BackupSelected
                            ? 'border-2 border-green-500 bg-mint-cream text-black'
                            : 'border-2 border-blue-500 bg-heart-of-ice text-black'
                        }`}
                      >
                        <div
                          className={`w-6 h-6 p-3px flex items-center justify-center"
                            ${
                              profileUserInfo.sb_profiles[0].profile_status === ProfileStatusMaster.BackupSelected
                                ? ' text-green-500 '
                                : ' text-blue-500 '
                            }`}
                        >
                          <BookmarkIcon className="w-4-2 h-4-2" aria-hidden="true" />
                        </div>
                        <span className="truncate flex-1" style={{}}>
                          {getSelectedUser(
                            profileUserInfo.sb_profiles[0].updated_by,
                            profileUserInfo.sb_profiles[0].profile_status
                          )}
                        </span>
                      </Button>
                    )} */}
            </>
          )
        }
      </>
    );
  };
  const HideUnhideButton = () => {
    return (
      <>
        {canHideProfiles() &&
          !isSbLocked &&
          !isSelectionDoneHideAll() &&
          profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard &&
          profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Selected &&
          !isSelectionDone && (
            <Button
              id={'sb_hide_profile_btn_id_' + profileIndex}
              variant="secondary"
              btn_size="small"
              disabled={isServerOperation}
              icon_position="ver"
              className="cursor-pointer w-full"
              onClick={() => {
                rejectClickHandler();
              }}
            >
              {isProfileHidden() ? (
                <>
                  <div className="w-6 h-6 p-3px flex items-center justify-center">
                    <EyeIcon className="w-4-2 h-4-2" aria-hidden="true" />
                  </div>
                  Unhide
                </>
              ) : (
                <>
                  <div className="w-6 h-6 p-3px flex items-center justify-center">
                    <EyeOffIcon className="w-4-2 h-4-2" aria-hidden="true" />
                  </div>
                  Hide
                </>
              )}
            </Button>
          )}
      </>
    );
  };
  const ContextMenu = () => {
    return (
      <>
        {!isSbLocked && (
          <Menu as="div" className="relative inline-block text-left">
            <Menu.Button
              id={'sb_perf_dots_id_' + profileIndex}
              disabled={isProfileHidden()}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderTopRightRadius = '8px';
                e.currentTarget.style.borderBottomRightRadius = '8px';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderTopRightRadius = '0px';
                e.currentTarget.style.borderBottomRightRadius = '0px';
              }}
              className={`flex items-center justify-center transition border-gray-300
                transition-all duration-150
            ${
              isProfileHidden()
                ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
                : 'hover:bg-gray-100 text-gray-500'
            }`}
            style={{ width: '36px', height: '28px', paddingLeft: '10px', paddingRight: '10px' }}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <EllipsisVerticalIcon className="w-4 h-4" />
              </div>
            </Menu.Button>

            <Menu.Items className="absolute -right-2 mt-2 w-48 origin-top-right  focus:outline-none z-50">
              <div
                className="absolute right-2 text-gray-300 text-center items-center flex w-4 h-4"
                style={{ zIndex: 51, top: '-0.5rem', width: '1rem' }}
              >
                <div
                  className="absolute right-2 w-4 h-4 border-t-2 border-l-2 border-gray-300 transform rotate-45 bg-white"
                  style={{
                    zIndex: 51,
                    top: '2px',
                  }}
                />
              </div>
              <div className="rounded-md py-1 px-1 gap-1 border-gray-300 border bg-white box-shadow-100 ring-1 ring-black ring-opacity-5 flex flex-col">
                {!isSbLocked && (
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        id={'sb_perf_dots_add_note_id_' + profileIndex}
                        className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                        onClick={(event: React.MouseEvent) => {
                          event.preventDefault();
                          setShowAddNoteModal(true);
                        }}
                      >
                        <div className="flex flex-row items-center font-medium text-sm  p-0 gap-2">
                          <NotepadTextIcon className="w-4 h-4" /> 
                          Add Note
                        </div>
                      </div>
                    )}
                  </Menu.Item>
                )}
                {fromScreen == fromRole.SB_CREATOR &&
                  !isSbLocked &&
                  profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Selected &&
                  profileUserInfo.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard && (
                    <Menu.Item>
                      {({ active }) => (
                        <div
                          id={'sb_perf_dots_req_media_id_' + profileIndex}
                          className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                          onClick={() => {
                            requestMediaClickHandler();
                          }}
                        >
                          <div className="flex flex-row items-center font-medium text-sm  p-0 gap-2">
                            <ClapperboardIcon className="w-4 h-4" /> 
                            Request Media
                          </div>
                        </div>
                      )}
                    </Menu.Item>
                  )}
              </div>
            </Menu.Items>
          </Menu>
        )}
      </>
    );
  };
  
  const isFavBlurred = () => {
    return (
      (profileUserInfo?.sb_profiles &&
        profileUserInfo?.sb_profiles.length > 0 &&
        profileUserInfo?.sb_profiles[0].profile_status === ProfileStatusMaster.Rejected) ||
      (isSelectionDone &&
        profileUserInfo?.sb_profiles[0].profile_status !== ProfileStatusMaster.Onboard &&
        profileUserInfo?.sb_profiles[0].profile_status !== ProfileStatusMaster.Selected)
    );
  };
  return (
    <div
      id={'profileid' + profileUserInfo.id}
      data-name={profileUserInfo.firstName}
      // removed h-full, as it was not working properly on iOS
        className={`h-full bg-white border 
          rounded-xl border border-gray-300 
          ${viewMode === 'grid' ? '  p-5 w-full ' : ' w-full '}
          ${isProfileHidden() ? '' : ''} flex pb-8  flex-col shadow-lg transition-all duration-300 overflow-visible`}
        style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)', minHeight:'20rem' }}
        >
      {selectedSubmissionBoard && (
        // removed h-full, as it was not working properly on iOS
        <div className="flex flex-col w-full ">
          {showModalNotes == true && (
            <div>
              <SbShowNotes
              
                profileUser={profileUserInfo}
                currentUser={currentUser}
                sb_recipient={sb_recipient}
                submissionBoardModel={selectedSubmissionBoard}
                project={project}
                isSbLocked={isSbLocked}
                dialogCloseHandler={(open: boolean) => {
                  setShowModalNotes(false);
                }}
                onNoteCountChange={(count: number) => {
                  setNoteCount(count);
                }}
                onProfileDataRefresh={() => {
                  // Refresh the submission board data to get latest profile info
                  if (refreshSubmissionBoard) {
                    refreshSubmissionBoard();
                  }
                }}
              ></SbShowNotes>
            </div>
          )}
          {showAddNoteModal && (
            <SbAddNote
              currentUser={currentUser}
              sb_recipient={sb_recipient}
              isSbLocked={isSbLocked}
              isOpen={showAddNoteModal}
              onClose={() => {
                setShowAddNoteModal(false);
              }}
              projectId={project.uuid}
              submissionBoardId={submissionBoardModel.id}
              profileId={profileUser.sb_profiles?.[0]?.sb_profile_id}
              profileName={(profileUser?.firstName ?? '') + ' ' + (profileUser?.lastName ?? '')}
              defaultUserAvatar={defaultUserAvatar}
              profileImage={profileUser?.croppedAvatarUrl ||  profileUser?.imageUrl || ''}
              submissionBoardName={submissionBoardModel.title}
              onNoteAdded={(note) => {
                if (refreshSubmissionBoard) {
                  refreshSubmissionBoard();
                }
              }}
            />
          )}
          {viewMode === 'grid' ? (
            // Grid mode: vertical card layout
            <div className="flex flex-col">
              {/* Image section */}
              <div className="relative">
                <div
                  ref={divRef}
                  style={{ height: `${heightImage}` }}
                  className="w-full relative overflow-hidden"
                >
                  <a
                    id={'performer_detail_sb_btn_id_' + profileIndex}
                    onClick={(event: React.MouseEvent) => {
                      event.preventDefault();
                      // console.log('Profile clicked for user:', profileUserInfo.firstName);
                      if (prevNextProfile) {
                        prevNextProfile(0, profileIndex);
                      }
                    }}
                    href="#"
                    className="block w-full h-full"
                  >
                    <Image
                     className={
                        'w-full h-full object-cover ' +
                        ((profileUserInfo?.sb_profiles &&
                          profileUserInfo?.sb_profiles.length > 0 &&
                          profileUserInfo?.sb_profiles[0].profile_status ==
                            ProfileStatusMaster.Rejected) ||
                        (isSelectionDone &&
                          profileUserInfo?.sb_profiles[0].profile_status !==
                            ProfileStatusMaster.Onboard &&
                          profileUserInfo?.sb_profiles[0].profile_status !==
                            ProfileStatusMaster.Selected)
                          ? ' opacity-30 '
                          : '')
                      }
                      src={hasValidProfileImage() ? getProfileImageUrl() : sbProfilePlaceholder}
                      fallbackSrc={hasValidProfileImage() ? whiteBgSbProfile : sbProfilePlaceholder}
                      alt=""
                      draggable="false"
                      onLoad={() => {
                        //  prevent expansion
                        calculateHeight();
                      }}
                    />
                    {/* <img
                      className={
                        'w-full h-full object-cover ' +
                        ((profileUserInfo?.sb_profiles &&
                          profileUserInfo?.sb_profiles.length > 0 &&
                          profileUserInfo?.sb_profiles[0].profile_status ==
                            ProfileStatusMaster.Rejected) ||
                        (isSelectionDone &&
                          profileUserInfo?.sb_profiles[0].profile_status !==
                            ProfileStatusMaster.Onboard &&
                          profileUserInfo?.sb_profiles[0].profile_status !==
                            ProfileStatusMaster.Selected)
                          ? ' opacity-30 '
                          : '')
                      }
                      src={profileUserInfo.imageUrl}
                      //project_placeholder@2x.jpg
                      draggable="false"
                    /> */}
                  </a>
                  {/* Heart icon in top-right */}
                  {!isFavBlurred()&&(
                  <div className="absolute top-1 right-1">
                    <button
                      id={'sb_perf_like_btn_id_' + profileIndex}
                      type="button"
                      className="absolute flex items-center justify-center h-11 w-11 top-1 right-1 rounded-full shadow-md hover:scale-110 transition-transform"
                      style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        color: 'rgba(255, 255, 255, 0.8)',
                      }}
                      disabled={isServerOperation}
                      onClick={async () => {
                        if (
                          sbProfileStatus?.profile_status == 'liked' ||
                          parseInt(sbProfileStatus?.profile_status) ==
                            RecipientProfileStatusMaster.Liked
                        ) {
                          await unlikeClickHandler();
                        } else {
                          await likeClickHandler();
                        }
                      }}
                    >
                      <div className="h-5 w-5">
                        {sbProfileStatus?.profile_status == 'liked' ||
                        parseInt(sbProfileStatus?.profile_status) ==
                          RecipientProfileStatusMaster.Liked ? (
                          <Star fill="white" className="h-5 w-5" />
                        ) : (
                          <Star className="h-5 w-5" />
                        )}
                      </div>
                    </button>
                    {/* <Star className="h-6 w-6 text-red-500" /> */}
                  </div>
                  )}
                </div>
              </div>

              {/* Content section */}
              <div className="p-1 flex flex-col gap-3 min-w-0 w-full">
                {/* Name */}
                <div className="text-center">
                  <h3 className="text-lg m-2 font-semibold text-gray-900">
                    {profileUserInfo.firstName} {profileUserInfo.lastName}
                  </h3>
                </div>

                {/* Profile stats */}
                <div className="flex justify-center gap-0 text-sm text-gray-600">
                  <div
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderTopLeftRadius = '8px';
                      e.currentTarget.style.borderBottomLeftRadius = '8px';
                      e.currentTarget.style.backgroundColor = '#f3f4f6'; // gray-100
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderTopLeftRadius = '0px';
                      e.currentTarget.style.borderBottomLeftRadius = '0px';
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    className="border-gray-300 border-r transition-all duration-150"
                    style={{
                      borderTopLeftRadius: '0px',
                      borderBottomLeftRadius: '0px',
                      overflow: 'hidden',
                      display: 'inline-flex',
                      alignItems: 'center',
                    }}
                  >
                  <InlineButton
                    id={'sb_perf_profile_id_' + profileIndex}
                    className="border-0 bg-transparent w-full h-full flex items-center justify-center gap-1 text-gray-700"
                    variant="secondary"
                    btn_size="small"
                    onClick={(event: React.MouseEvent) => {
                      event.preventDefault();
                      if (prevNextProfile) {
                        prevNextProfile(0, profileIndex);
                      }
                    }}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <SquareUserIcon className="w-4 h-4" />
                    </div>
                    Profile
                  </InlineButton>
                  </div>
                  <InlineButton
                    id={'sb_perf_media_id_' + profileIndex}
                    className="border-gray-300 border-r"
                    variant="secondary"
                    btn_size="small"
                    onClick={(event: React.MouseEvent) => {
                      event.preventDefault();
                      if (prevNextProfile) {
                        prevNextProfile(0, profileIndex);
                      }
                    }}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <FilmIcon className="w-4 h-4" />
                    </div>
                    {documentCount}
                  </InlineButton>
                  <InlineButton
                    id={'sb_perf_notes_id_' + profileIndex}
                    className="border-gray-300 border-r"
                    variant="secondary"
                    btn_size="small"
                    onClick={(event: React.MouseEvent) => {
                      event.preventDefault();
                      setShowModalNotes(true);
                    }}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <NotepadTextIcon className="w-4 h-4" />
                    </div>
                    {noteCount}
                  </InlineButton>
                  <ContextMenu />
                </div>

                {/* Action buttons */}
                <div className="flex flex-col gap-3 min-w-0">
                  {/* Top row: Backup / Remove performer / hide/unhide */}
                  {fromScreen == fromRole.SB_CREATOR && !isSbLocked && (
                    <div className="flex gap-2 min-w-0 w-full">
                      {/* Backup button start */}
                      {isBackupButtonVisible() && (
                        <div className="flex-1 min-w-0">
                          <BackupButton icon_position="ver" />
                        </div>
                      )}
                      {/* Backup button end */}
                      {/* Hide/Unhide button start */}
                      {canHideProfiles() &&
                        !isSelectionDoneHideAll() &&
                        profileUserInfo.sb_profiles[0].profile_status !==
                          ProfileStatusMaster.Onboard &&
                        profileUserInfo.sb_profiles[0].profile_status !==
                          ProfileStatusMaster.Selected &&
                        !isSelectionDone && (
                          <div className="flex-1 min-w-0">
                            <HideUnhideButton />
                          </div>
                        )}
                      {/* Hide/Unhide button end */}
                      {/* Remove Performer button start */}
                      {!isSbLocked &&
                        !isSelectionDoneHideAll() &&
                        profileUserInfo.sb_profiles[0].profile_status !==
                          ProfileStatusMaster.Onboard &&
                        profileUserInfo.sb_profiles[0].profile_status !==
                          ProfileStatusMaster.Selected &&
                        !isSelectionDone && (
                          <div className="flex-1 min-w-0">
                            <Button
                              id={'sb_remove_profile_btn_id_' + profileIndex}
                              variant="secondary"
                              btn_size="small"
                              icon_position="ver"
                              className={`w-full 
                            ${
                              isProfileHidden()
                                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                : ''
                            }`}
                              disabled={isProfileHidden() || isServerOperation}
                              onClick={() => {
                                removePerformerFromSbClickHandler();
                              }}
                            >
                              <div className="w-6 h-6 p-3px flex items-center justify-center">
                                <CircleMinusIcon className="w-4-2 h-4-2" aria-hidden="true" />
                              </div>
                              Remove
                            </Button>
                          </div>
                        )}
                      {/* Remove Performer button end */}
                    </div>
                  )}
                  {/* Final Selection button start */}
                  <FinalButton />
                  {/* Final Selection button end */}
                  {/* Selected by, Add to team, Remove Selection start */}
                  {profileUserInfo &&
                    (profileUserInfo.sb_profiles[0].profile_status ==
                      ProfileStatusMaster.Selected ||
                      profileUserInfo.sb_profiles[0].profile_status ==
                        ProfileStatusMaster.Onboard ||
                      profileUserInfo.sb_profiles[0].profile_status ==
                        ProfileStatusMaster.BackupSelected) && (
                      <>
                        {/* Selected or onboarded info button start */}
                        <ShowBackSelectedInfo />
                        <ShowSelectedOnboardedInfo />
                        {/* Selected or onboarded info button end */}
                        {/* Add to Team start */}
                        <AddToTeamButton />
                        {/* Add to Team end */}

                        {/* remove selection start */}
                        <RemoveSelectionButton />
                        {/* remove selection start */}
                      </>
                    )}
                  {/* Selected by, Add to team, Remove Selection end*/}
                </div>
                <PreferredByRecipient
                  submissionBoardModel={selectedSubmissionBoard}
                  sb_profiles_statuses={profileUserInfo?.sb_profiles?.[0]?.sb_profiles_statuses}
                  variant={'hor'}
                  isTop={true}
                  isPreferredBy={function (likecount: number): void {}}
                />
              </div>
            </div>
          ) : (
            // List mode: horizontal layout
            <div className="flex py-5 pr-5 min-h-full	">
              {fromScreen === fromRole.SB_CREATOR && (
                <>
                  {!isSbLocked && !isSelectionDoneHideAll() ? (
                    <div
                      className="flex px-3 items-center drag-handle hover:bg-gray-100 cursor-move"
                      // className="drag-handle absolute top-3 left-3 z-20 bg-white hover:bg-gray-100 px-2 py-1 rounded text-xs border shadow-sm"
                      title="Drag to reorder profiles"
                    >
                      <img src={SixDots}></img>
                    </div>
                  ) : (
                    <div className="flex px-3 items-center"></div>
                  )}
                </>
              )}
              {fromScreen !== fromRole.SB_CREATOR && <div className="flex px-3 items-center"></div>}
              {/* Image section */}
              <div className="relative flex-shrink-0">
                  <div className="w-48 min-h-full	relative overflow-hidden">

                  <a
                    id={'performer_detail_sb_btn_id_' + profileUserInfo.id}
                    onClick={(event: React.MouseEvent) => {
                      event.preventDefault();
                      // console.log('Profile clicked for user:', profileUserInfo.firstName);
                      if (prevNextProfile) {
                        prevNextProfile(0, profileIndex);
                      }
                    }}
                    href="#"
                    className="block w-full min-h-full	"
                  >
                    <Image
                      className={
                        'w-full h-full object-cover ' +
                        ((profileUserInfo?.sb_profiles &&
                          profileUserInfo?.sb_profiles.length > 0 &&
                          profileUserInfo?.sb_profiles[0].profile_status ==
                            ProfileStatusMaster.Rejected) ||
                        (isSelectionDone &&
                          profileUserInfo?.sb_profiles[0].profile_status !==
                            ProfileStatusMaster.Onboard &&
                          profileUserInfo?.sb_profiles[0].profile_status !==
                            ProfileStatusMaster.Selected)
                          ? ' opacity-30 '
                          : '')
                      }
                      src={hasValidProfileImage() ? getProfileImageUrl() : sbProfilePlaceholder}
                      fallbackSrc={hasValidProfileImage() ? whiteBgSbProfile : sbProfilePlaceholder}
                      alt=""
                      draggable="false"
                      onLoad={() => {
                        // Recalculate height when image loads to prevent expansion
                        calculateHeight();
                      }}
                    />
                  </a>

                  {/* Heart icon in top-right */}
                  {!isFavBlurred() &&(
                  <div className="absolute top-1 right-1">
                    <button
                      id={'sb_perf_like_btn_id_' + profileIndex}
                      type="button"
                      className="absolute flex items-center justify-center h-11 w-11 top-1 right-1 rounded-full shadow-md hover:scale-110 transition-transform"
                      style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        color: 'rgba(255, 255, 255, 0.8)',
                      }}
                      disabled={isServerOperation}
                      onClick={async () => {
                        if (
                          sbProfileStatus?.profile_status == 'liked' ||
                          parseInt(sbProfileStatus?.profile_status) ==
                            RecipientProfileStatusMaster.Liked
                        ) {
                          await unlikeClickHandler();
                        } else {
                          await likeClickHandler();
                        }
                      }}
                    >
                      <div className="h-5 w-5">
                        {sbProfileStatus?.profile_status == 'liked' ||
                        parseInt(sbProfileStatus?.profile_status) ==
                          RecipientProfileStatusMaster.Liked ? (
                          <Star fill="white" className="h-5 w-5" />
                        ) : (
                          <Star className="h-5 w-5" />
                        )}
                      </div>
                    </button>
                  
                    {/* <Star className="h-6 w-6 text-red-500" /> */}
                  </div>
                    )}
                </div>
              </div>

              {/* Content section */}
              <div className="flex-1 px-2 flex flex-row justify-between">
                {/* Middle section: Action buttons */}
                <div className="flex flex-col w-full gap-4 px-4 mb-4">
                  {/* Left side: Backup / Remove / Reject */}
                  <div className="flex flex-row gap-4 justify-between">
                    <h3 className="text-lg font-semibold text-gray-900">
                      {profileUserInfo.firstName} {profileUserInfo.lastName}
                    </h3>
                    <div className="flex flex-row items-center justify-center cursor-pointer">
                      <InlineButton
                        id={'sb_perf_profile_id_' + profileIndex}
                        className="border-gray-300 border-r"
                        variant="secondary"
                        btn_size="small"
                        onClick={(event: React.MouseEvent) => {
                          event.preventDefault();
                          if (prevNextProfile) {
                            prevNextProfile(0, profileIndex);
                          }
                        }}
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <SquareUserIcon className="w-4 h-4" />
                        </div>
                        Profile
                      </InlineButton>

                      <InlineButton
                        id={'sb_perf_media_id_' + profileIndex}
                        className="border-gray-300 border-r"
                        variant="secondary"
                        btn_size="small"
                        onClick={(event: React.MouseEvent) => {
                          event.preventDefault();
                          if (prevNextProfile) {
                            prevNextProfile(0, profileIndex);
                          }
                        }}
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <FilmIcon className="w-4 h-4" />
                        </div>
                        {documentCount}
                      </InlineButton>
                      <InlineButton
                        id={'sb_perf_notes_id_' + profileIndex}
                        className="border-gray-300 border-r"
                        variant="secondary"
                        btn_size="small"
                        onClick={(event: React.MouseEvent) => {
                          event.preventDefault();
                          setShowModalNotes(true);
                        }}
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <NotepadTextIcon className="w-4 h-4" />
                        </div>
                        {noteCount}
                      </InlineButton>
                      <div className="flex items-center gap-4 text-sm text-gray-600 px-2">
                        <ContextMenu />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row gap-4 ">
                    {/* buttons start */}
                    <div className="flex flex-1 flex-col gap-4">
                      {fromScreen === fromRole.SB_CREATOR && (
                        <div className="flex flex-row gap-4 justify-start">
                          {/* Backup button start */}
                          {isBackupButtonVisible() && (
                            <div className="flex-1 min-w-0">
                              <BackupButton icon_position="ver" />
                            </div>
                          )}
                          {/* Backup button end */}

                          {/* hide/unhide profile button */}
                          {canHideProfiles() &&
                            !isSbLocked &&
                            !isSelectionDoneHideAll() &&
                            profileUserInfo.sb_profiles[0].profile_status !==
                              ProfileStatusMaster.Onboard &&
                            profileUserInfo.sb_profiles[0].profile_status !==
                              ProfileStatusMaster.Selected &&
                            !isSelectionDone && (
                              <div className="flex-1 min-w-0">
                                <HideUnhideButton />
                              </div>
                            )}
                          {/* {canHideProfiles() &&
                            !isSbLocked &&
                            !isSelectionDoneHideAll() &&
                            profileUserInfo.sb_profiles[0].profile_status !==
                              ProfileStatusMaster.Onboard &&
                            profileUserInfo.sb_profiles[0].profile_status !==
                              ProfileStatusMaster.Selected &&
                            !isSelectionDone && (
                              <Button
                                id={'sb_hide_profile_btn_id_' + profileIndex}
                                variant="secondary"
                                btn_size="small"
                                icon_position="hor"
                                className="cursor-pointer"
                                onClick={() => {
                                  rejectClickHandler();
                                }}
                              >
                                {isProfileHidden() ? (
                                  <>
                                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                                      <EyeIcon className="w-4-2 h-4-2" aria-hidden="true" />
                                    </div>
                                    Unhide
                                  </>
                                ) : (
                                  <>
                                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                                      <EyeOffIcon className="w-4-2 h-4-2" aria-hidden="true" />
                                    </div>
                                    Hide
                                  </>
                                )}
                              </Button>
                            )} */}
                          {/* hide/unhide profile button */}
                          {/* remove profile button */}
                          {!isSbLocked &&
                            !isSelectionDoneHideAll() &&
                            profileUserInfo.sb_profiles[0].profile_status !==
                              ProfileStatusMaster.Onboard &&
                            profileUserInfo.sb_profiles[0].profile_status !==
                              ProfileStatusMaster.Selected &&
                            !isSelectionDone && (
                              <div className="flex-1 min-w-0">
                                <Button
                                  id={'sb_remove_profile_btn_id_' + profileIndex}
                                  variant="secondary"
                                  btn_size="small"
                                  icon_position="ver"
                                  className={`w-full
                              ${
                                isProfileHidden()
                                  ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                  : ''
                              }`}
                                  disabled={isProfileHidden()}
                                  onClick={() => {
                                    removePerformerFromSbClickHandler();
                                  }}
                                >
                                  <div className="w-6 h-6 p-3px flex items-center justify-center">
                                    <CircleMinusIcon className="w-4-2 h-4-2" aria-hidden="true" />
                                  </div>
                                  Remove
                                </Button>
                              </div>
                            )}
                          {/* remove profile button */}
                        </div>
                      )}
                      {/* Right side*/}
                      <div className="gap-2 flex flex-col">
                        {/* Final Selection button start */}
                        <FinalButton />
                        {/* Final Selection button end */}
                        {/* Selected by, Add to team, Remove Selection start */}
                        {profileUserInfo &&
                          (profileUserInfo.sb_profiles[0].profile_status ==
                            ProfileStatusMaster.Selected ||
                            profileUserInfo.sb_profiles[0].profile_status ==
                              ProfileStatusMaster.Onboard ||
                            profileUserInfo.sb_profiles[0].profile_status ==
                              ProfileStatusMaster.BackupSelected) && (
                            <>
                              {/* Selected or onboarded info button start */}
                              <ShowBackSelectedInfo />
                              <ShowSelectedOnboardedInfo />
                              {/* Selected or onboarded info button end */}
                              {/* Add to Team start */}
                              <AddToTeamButton />
                              {/* Add to Team end */}

                              {/* remove selection start */}
                              <RemoveSelectionButton />
                              {/* remove selection start */}
                            </>
                          )}
                      </div>
                    </div>
                    {/* buttons end */}
                    {/* demographics start */}
                    <div className="hidden sm:flex flex-col text-sm text-black-400  px-2 mt-1 sm:border-l-2  sm:border-gray-200"
                    style={{
                      maxWidth: '15.625rem'
                    }}>
                      <div className="leading-5 truncate">
                        {humanize(profileUserInfo?.gender)}
                      </div>
                      <div className="leading-5 truncate">
                        {getProfileHeightString(profileUserInfo, currentUser)}
                        {getProfileHeightString(profileUserInfo, currentUser) && getProfileWeightString(profileUserInfo, currentUser) ? ' / ' : ''}
                        {getProfileWeightString(profileUserInfo, currentUser)}
                      </div>
                      <div className="leading-5 flex flex-wrap">
                        {profileUserInfo?.ethnicities && profileUserInfo.ethnicities.length > 0
                          ? humanize(profileUserInfo.ethnicities.join(', '))
                          : ''}
                      </div>
                      <div className="leading-5 truncate">
                        {humanize(profileUserInfo?.hair_make_up_kit?.eye_color)}
                        {profileUserInfo?.hair_make_up_kit?.eye_color && profileUserInfo?.hair_make_up_kit?.hair_color ? ' / ' : ''}
                        {humanize(profileUserInfo?.hair_make_up_kit?.hair_color)}
                      </div>
                    </div>
                    {/* demographics end */}
                    {/* preferred start */}
                    <div
                  className={`hidden sm:flex flex-col text-sm text-black-400 ${
                    profileUserInfo?.sb_profiles?.[0]?.sb_profiles_statuses?.length > 0
                      ? 'px-2 mt-1 sm:border-l-2 sm:border-gray-200'
                      : ''
                  }`}
                  style={{ maxWidth: '9.375rem' }}
                >
                  <PreferredByRecipient
                    submissionBoardModel={selectedSubmissionBoard}
                    sb_profiles_statuses={profileUserInfo?.sb_profiles?.[0]?.sb_profiles_statuses}
                    variant={'ver'}
                    isTop={true}
                    isPreferredBy={(likecount: number): void => {}}
                  />
                </div>

                    {/* preferred end */}
                  </div>
                </div>
              </div>
            </div>
          )}
          {selectedSubmissionBoard != null && profileUserInfo != null && showMediaRequestModal && (
            <SbMediaRequestNote
              onClose={function (): void {
                setShowMediaRequestModal(false);
              }}
              project={project}
              submissionBoardModel={selectedSubmissionBoard}
              profileUserInfo={profileUserInfo}
              defaultUserAvatar={defaultUserAvatar} 
            />
          )}
          <ConfirmationDialog
            title="Confirm Final Selection"
            description={
              "You are about to select <span class='font-bold'>" +
              profileUserInfo.firstName +
              ' ' +
              profileUserInfo.lastName +
              "</span>. This will be the final performer selection for <span class='font-bold'>" +
              submissionBoardModel.title +
              '</span>. Everyone will be notified that the role has been filled.<br/><br/>Are you sure this is your final choice?<br/><br/>'
            }
            onCancelLabel="Cancel"
            onCancelAction={confirmDialogActions?.onCancel}
            onConfirmLabel="Confirm"
            confirmVariant="primary"
            onConfirmAction={confirmDialogActions?.onConfirm}
            isOpen={showConfirmationModal}
            onClose={confirmDialogActions?.onCancel}
            icon={
              <div className="rounded-full p-3 bg-blue-200">
                <CheckCircleIcon className="w-6 h-6 text-blue-500 " />
              </div>
            }
          />
        </div>
      )}
    </div>
  );
};
